import i18n from './i18n';

// Ajustes globais de acessibilidade, ligados uma vez em index.js.

// 1) <html lang> acompanha o idioma da interface (leitores de tela escolhem a
//    voz e a pronúncia por ele). O i18n usa códigos curtos; o atributo leva a
//    variante regional que a plataforma fala.
export const LANG_DO_IDIOMA = {
  pt: 'pt-BR',
  en: 'en',
  es: 'es',
  fr: 'fr',
  it: 'it',
  de: 'de',
  zh: 'zh-CN',
};

export const langDoIdioma = (idioma) => {
  const curto = String(idioma || 'pt').toLowerCase().split('-')[0];
  return LANG_DO_IDIOMA[curto] || LANG_DO_IDIOMA.pt;
};

const aplicarLang = (idioma) => {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('lang', langDoIdioma(idioma || i18n.resolvedLanguage || i18n.language));
};

// 2) Modo teclado: html[data-navegacao="teclado"] enquanto a pessoa navega
//    com Tab, desligado no primeiro clique/toque. O CSS usa isso para mostrar o
//    anel de foco também nos campos de texto (que, no Chrome, casam com
//    :focus-visible até no clique do mouse) sem mudar nada para quem usa mouse.
const ligarModoTeclado = () => {
  if (typeof document === 'undefined') return;
  const raiz = document.documentElement;
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Tab' && raiz.dataset.navegacao !== 'teclado') raiz.dataset.navegacao = 'teclado';
  }, true);
  const desligar = () => {
    if (raiz.dataset.navegacao) delete raiz.dataset.navegacao;
  };
  document.addEventListener('pointerdown', desligar, true);
  document.addEventListener('mousedown', desligar, true);
};

let iniciado = false;
export const iniciarAcessibilidade = () => {
  if (iniciado) return;
  iniciado = true;
  aplicarLang();
  i18n.on('initialized', () => aplicarLang());
  i18n.on('languageChanged', aplicarLang);
  ligarModoTeclado();
};
